import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { get } from "vuex-pathify";
import MlFaq from "@/components/MlFaq";
import validatorService from "@/services/validator";
import rules from "@/assets/js/rules";
import { isSupported } from "firebase/messaging";
import Vue from "vue";
import { mapActions } from "vuex";
import MlFooter from "@/components/MlFooter";
import empresaService from "@/services/empresa";
export default {
  data: function data() {
    return {
      exibirFaq: false,
      rules: rules,
      valid: true,
      error: false,
      verificar: false,
      digitandoMensagem: false,
      suportaNotificacao: false,
      segundos: 5,
      mensagens: [],
      identificador: null,
      inputs: {
        email: "",
        tel: ""
      }
    };
  },
  components: {
    MlFaq: MlFaq,
    MlFooter: MlFooter
  },
  computed: {
    cliente: get("auth/cliente"),
    empresa: get("auth/empresa"),
    preAutenticando: get("auth/preAutenticando"),
    regressiva: function regressiva() {
      if (!this.cliente.autosservico) {
        if (this.segundos == 5) this.contagem();
        if (this.segundos == 0) {
          this.handleRedirect();
        }
        return "Redirecionando em (" + this.segundos + ")";
      } else {
        if (this.segundos == 5) this.contagem();
        if (this.segundos == 0) return "Acesse agora";
        return "Fechando (" + this.segundos + ")";
      }
    },
    mostraRodape: function mostraRodape() {
      return this.$route.meta.rodape && this.empresa.chave === "digio";
    }
  },
  watch: {
    cliente: {
      handler: function handler() {
        if (this.cliente.id) {
          this.atualizarInfosCliente();
          this.removerMensagens(3);
          this.carregarMensagens();
        }
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (_this.cliente.id) _this.atualizarInfosCliente();
            _this.identificador = _this.$route.query.identificador || _this.$store.state.auth.identificador;
            isSupported().then(function (suportaNotificacao) {
              _this.suportaNotificacao = suportaNotificacao;
            });
            _this.carregarMensagens();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    this.scrollDown();
  },
  updated: function updated() {
    this.scrollDown();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("notification", ["cadastrarToken", "cadastrarEmail", "cadastrarSms", "cadastrarLigacao", "cadastrarWhatsapp"])), {}, {
    carregarMensagens: function carregarMensagens() {
      if (!this.cliente.nome) {
        this.exibirFaq = true;
        return;
      }
      if (this.cliente.tem_email && this.cliente.tem_whatsapp && this.cliente.telefone && this.cliente.tem_push) {
        this.exibirFaq = true;
        return;
      }
      if (!this.cliente.tem_email) {
        this.adicionarMensagens(this.mensagemPedirEmail());
        return;
      }
      // whatsapp ja vai ser solicitado pelo dialog optin whatsapp,
      // não tem porque pedir aqui novamente.

      // if (!this.cliente.telefone && !this.cliente.tem_whatsapp) {
      //   this.verificar = true;
      //   this.adicionarMensagens(this.mensagemPedirWhatsapp(), 1000);
      //   return;
      // }
      // if (!this.cliente.tem_whatsapp) {
      //   if (
      //     this.cliente.telefone &&
      //     !this.cliente.telefone.startsWith("(**)")
      //   ) {
      //     this.adicionarMensagens(this.mensagemVerificaWhatsapp());
      //     return;
      //   } else {
      //     this.verificar = true;
      //     this.adicionarMensagens(this.mensagemPedirWhatsapp());
      //     return;
      //   }
      // }
      if (!this.cliente.tem_push) {
        this.adicionarMensagens(this.mensagemPedirPush());
        return;
      }
    },
    // mensagens relacionadas ao whatsapp ----------------------------------------------------------------------------------------------------------------------
    mensagemPedirWhatsapp: function mensagemPedirWhatsapp(texto) {
      var _this2 = this;
      var conteudo = texto || "".concat(this.cliente.nome.split(" ")[0], ", tudo bem? Poderia nos informar seu WhatsApp?");
      return [{
        tipo: "texto-sistema",
        conteudo: conteudo
      }, {
        tipo: "input",
        conteudo: {
          tipo: "tel",
          label: "WhatsApp",
          placeholder: "(00) 00000-0000",
          inputmode: "inputmode",
          icon: "mdi-whatsapp",
          rules: this.rules.whatsapp,
          mask: "(##) #####-####",
          model: "tel",
          submit: function submit() {
            return _this2.salvarWhatsApp(false);
          }
        }
      }, {
        notMt: true,
        tipo: "button",
        conteudo: [{
          texto: "Enviar",
          depressed: true,
          func: function func() {
            return _this2.salvarWhatsApp(false);
          }
        }]
      }];
    },
    mensagemErroWhatsapp: function mensagemErroWhatsapp(respostaNumero) {
      var _this3 = this;
      return [{
        tipo: "erro",
        conteudo: "Ops! Algo deu errado na hora de salvar seu WhatsApp! Tente \
                novamente!"
      }, {
        tipo: "input",
        conteudo: {
          tipo: "tel",
          label: "WhatsApp",
          placeholder: "(00) 00000-0000",
          inputmode: "inputmode",
          icon: "mdi-whatsapp",
          rules: this.rules.whatsapp,
          mask: "(##) #####-####",
          model: "tel",
          submit: function submit() {
            return _this3.salvarWhatsApp(respostaNumero);
          }
        }
      }, {
        notMt: true,
        tipo: "button",
        conteudo: [{
          texto: "Enviar",
          depressed: true,
          func: function func() {
            return _this3.salvarWhatsApp(respostaNumero);
          }
        }]
      }];
    },
    mensagemRetryWhatsapp: function mensagemRetryWhatsapp() {
      var _this4 = this;
      return [{
        tipo: "erro",
        conteudo: "Ops! Algo deu errado na hora de salvar seu WhatsApp! Tente \
                novamente!"
      }, {
        tipo: "button",
        conteudo: [{
          texto: "Não",
          outlined: true,
          func: function func() {
            return _this4.numeroCorreto(false);
          }
        }, {
          texto: "Sim",
          depressed: true,
          func: function func() {
            return _this4.numeroCorreto(true);
          }
        }]
      }];
    },
    mensagemVerificaWhatsapp: function mensagemVerificaWhatsapp(texto) {
      var _this5 = this;
      var conteudo = texto || "".concat(this.cliente.nome.split(" ")[0], ", tudo bem? Esse telefone \xE9 seu WhatsApp? ");
      return [{
        tipo: "texto-sistema",
        conteudo: conteudo
      }, {
        tipo: "whatsapp",
        conteudo: this.cliente.telefone
      }, {
        tipo: "button",
        conteudo: [{
          texto: "Não",
          outlined: true,
          func: function func() {
            return _this5.numeroCorreto(false);
          }
        }, {
          texto: "Sim",
          depressed: true,
          func: function func() {
            return _this5.numeroCorreto(true);
          }
        }]
      }];
    },
    numeroCorreto: function numeroCorreto() {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var resposta;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              resposta = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              _this6.removerMensagens(_this6.error ? 2 : 1);
              _this6.verificar = !resposta;
              if (!resposta) {
                _context2.n = 1;
                break;
              }
              _this6.adicionarMensagens([{
                tipo: "texto-cliente",
                conteudo: "Sim"
              }]);
              _this6.salvarWhatsApp(resposta);
              _context2.n = 3;
              break;
            case 1:
              _this6.adicionarMensagens([{
                tipo: "texto-cliente",
                conteudo: "Não"
              }]);
              _this6.digitandoMensagem = true;
              _context2.n = 2;
              return _this6.sleep();
            case 2:
              _this6.digitandoMensagem = false;
              _this6.adicionarMensagens(_this6.mensagemPedirWhatsapp("Então, poderia nos informar seu WhatsApp correto?"));
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    // mensagens relacionadas a email ---------------------------------------------------------------------------------------------------------------------------
    mensagemPedirEmail: function mensagemPedirEmail(texto) {
      var _this7 = this;
      var conteudo = texto || "".concat(this.cliente.nome.split(" ")[0], ", tudo bem?\n            Poderia, por gentileza, nos informar seu melhor e-mail para comunicados importantes ").concat(this.handleEmpresaGenero(), " ").concat(this.empresa.nome, "?");
      return [{
        tipo: "texto-sistema",
        conteudo: conteudo
      }, {
        tipo: "input",
        conteudo: {
          tipo: "email",
          label: "E-mail",
          placeholder: "exemplo@exemplo.com",
          icon: "mdi-email-outline",
          rules: this.rules.email,
          model: "email",
          submit: function submit() {
            return _this7.salvarEmail();
          }
        }
      }, {
        notMt: true,
        tipo: "button",
        conteudo: [{
          texto: "Enviar",
          depressed: true,
          func: function func() {
            return _this7.salvarEmail();
          }
        }]
      }];
    },
    mensagemErroEmail: function mensagemErroEmail() {
      var _this8 = this;
      return [{
        tipo: "erro",
        conteudo: "Ops! Algo deu errado na hora de salvar seu e-mail! Tente \
              novamente!"
      }, {
        tipo: "input",
        conteudo: {
          tipo: "email",
          label: "E-mail",
          placeholder: "exemplo@exemplo.com",
          icon: "mdi-email-outline",
          rules: this.rules.email,
          model: "email",
          submit: function submit() {
            return _this8.salvarEmail();
          }
        }
      }, {
        notMt: true,
        tipo: "button",
        conteudo: [{
          texto: "Enviar",
          depressed: true,
          func: function func() {
            return _this8.salvarEmail();
          }
        }]
      }];
    },
    // mensagens relacionadas a notificações push ---------------------------------------------------------------------------------------------------------------
    mensagemPedirPush: function mensagemPedirPush(texto) {
      var _this9 = this;
      var conteudo = texto || "".concat(this.cliente.nome.split(" ")[0], ", tudo bem? Voc\xEA aceita receber nossas notifica\xE7\xF5es? Assim voc\xEA             n\xE3o perde nenhuma informa\xE7\xE3o sobre seus pr\xF3ximos boletos.             Lembrando que \xE9 necess\xE1rio permitir as notifica\xE7\xF5es no seu             navegador.");
      return [{
        tipo: "texto-sistema",
        conteudo: conteudo
      }, {
        tipo: "button",
        conteudo: [{
          texto: "Não aceito",
          outlined: true,
          func: function func() {
            return _this9.salvarPush(false);
          }
        }, {
          texto: "Aceito",
          depressed: true,
          func: function func() {
            return _this9.salvarPush();
          }
        }]
      }];
    },
    mensagemPushAceito: function mensagemPushAceito() {
      return [{
        tipo: "texto-sistema",
        conteudo: "Obrigada, ".concat(this.cliente.nome, "! Voc\xEA sempre pode                   contar com a gente! :)")
      }];
    },
    mensagemPushRecusado: function mensagemPushRecusado() {
      return [{
        tipo: "texto-sistema",
        conteudo: "Que pena, ".concat(this.cliente.nome, "! Mas voc\xEA sempre pode               contar com a gente, viu? :)")
      }];
    },
    mensagemRetryPush: function mensagemRetryPush() {
      var _this0 = this;
      return [{
        tipo: "erro",
        conteudo: "Ops! Algo deu errado na hora de aceitar a notificação! \
                  Tente novamente!"
      }, {
        tipo: "button",
        conteudo: [{
          texto: "Não aceito",
          outlined: true,
          func: function func() {
            return _this0.salvarPush(false);
          }
        }, {
          texto: "Aceito",
          depressed: true,
          func: function func() {
            return _this0.salvarPush();
          }
        }]
      }];
    },
    // mensagem finalizadora da conversa -----------------------------------------------------------------------------------------------------------------------
    mensagemSucesso: function mensagemSucesso() {
      var _this1 = this;
      return [{
        tipo: "texto-sistema",
        conteudo: !this.cliente.autosservico ? "Obrigada, ".concat(this.cliente.nome, "! Agora voc\xEA pode contar com a gente para sempre ter em m\xE3os as informa\xE7\xF5es mais importantes ").concat(this.handleEmpresaGenero(), " ").concat(this.empresa.nome, ". \n                 Em breve voc\xEA ser\xE1 redirecionado ao site ").concat(this.handleEmpresaGenero(), " ").concat(this.empresa.nome) : "Você pode acessar as informações sobre seu contrato e demais \
                boletos na nossa área logada. Combinado?"
      }, {
        tipo: "arealogada",
        texto: null
      }, {
        tipo: "button",
        conteudo: [{
          texto: "func:regressiva",
          depressed: true,
          func: function func() {
            _this1.$store.state.chat.aberto = false;
          }
        }]
      }];
    },
    handleRedirect: function handleRedirect() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, url_redirect, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                registrar_acesso: false
              };
              _context3.n = 1;
              return empresaService.redirecionarAreaLogada(_this10.identificador, params);
            case 1:
              url_redirect = _context3.v;
              window.location.href = url_redirect.data;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              console.error(_t);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    handleEmpresaGenero: function handleEmpresaGenero() {
      return this.empresa.genero === "M" ? "do" : "da";
    },
    sleep: function sleep() {
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    scrollDown: function scrollDown() {
      setTimeout(function () {
        var objDiv = document.getElementById("mensagens");
        if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      });
    },
    adicionarMensagens: function adicionarMensagens(mensagens) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              mensagens.forEach(function (mensagem) {
                _this11.mensagens.push(mensagem);
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    removerMensagens: function removerMensagens() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.mensagens.splice(-1 * total, total);
    },
    validar: function validar() {
      var index = this.$refs.form.length - 1;
      if (this.$refs.form[index].validate()) return true;
      return false;
    },
    textoDinamico: function textoDinamico(texto) {
      if (texto.indexOf("func:") !== -1) {
        return this[texto.split(":")[1]];
      }
      return texto;
    },
    contagem: function contagem() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(_this12.segundos == 0)) {
                _context5.n = 1;
                break;
              }
              _this12.$store.state.chat.aberto = false;
              _context5.n = 3;
              break;
            case 1:
              _context5.n = 2;
              return _this12.sleep();
            case 2:
              _this12.segundos--;
              _this12.contagem();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    salvarEmail: function salvarEmail() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (_this13.validar()) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              _this13.removerMensagens(_this13.error ? 3 : 2);
              _this13.adicionarMensagens([{
                tipo: "texto-cliente",
                conteudo: _this13.inputs.email
              }]);
              _this13.error = false;
              _this13.digitandoMensagem = true;
              _context6.n = 2;
              return validatorService.validarEmail(_this13.inputs.email).then(function (resposta) {
                var validador = resposta.data;
                if (validador.suggestion) {
                  _this13.inputs.email = validador.suggestion;
                }
              })["catch"](function (err) {
                console.log(err);
              });
            case 2:
              _context6.n = 3;
              return _this13.sleep();
            case 3:
              _context6.p = 3;
              _context6.n = 4;
              return _this13.cadastrarEmail({
                email: _this13.inputs.email,
                identificador: _this13.identificador
              });
            case 4:
              _this13.$store.state.chat.mensagens--;
              _context6.n = 5;
              return _this13.sleep();
            case 5:
              _this13.digitandoMensagem = false;

              // whatsapp ja vai ser solicitado pelo dialog optin whatsapp,
              // não tem porque pedir aqui novamente.

              // if (!this.cliente.tem_whatsapp) {
              // this.adicionarMensagens([
              //   {
              //     tipo: "texto-sistema",
              //     conteudo: "Mais uma coisa...",
              //   },
              // ]);
              // await this.sleep();
              // if (this.cliente.telefone) {
              //   this.adicionarMensagens(
              //     this.mensagemVerificaWhatsapp(
              //       "Esse telefone é seu WhatsApp também?",
              //     ),
              //   );
              // } else {
              //   this.verificar = true;
              //   this.adicionarMensagens(
              //     this.mensagemPedirWhatsapp("Poderia nos informar seu WhatsApp?"),
              //   );
              // }
              // } else 
              if (_this13.cliente.tem_push) {
                _context6.n = 7;
                break;
              }
              _this13.adicionarMensagens([{
                tipo: "texto-sistema",
                conteudo: "Mais uma coisa..."
              }]);
              _context6.n = 6;
              return _this13.sleep();
            case 6:
              // erro aqui
              _this13.adicionarMensagens(_this13.mensagemPedirPush("Perfeito! Agora, você aceita receber nossas notificações? \
                Assim você não perde nenhuma informação sobre seus próximos \
                boletos. Lembrando que é necessário permitir as notificações \
                no seu navegador."));
              _context6.n = 8;
              break;
            case 7:
              _this13.adicionarMensagens(_this13.mensagemSucesso());
            case 8:
              _context6.n = 10;
              break;
            case 9:
              _context6.p = 9;
              _t2 = _context6.v;
              console.error(_t2);
              _this13.removerMensagens();
              _this13.error = true;
              _this13.adicionarMensagens(_this13.mensagemErroEmail());
            case 10:
              return _context6.a(2);
          }
        }, _callee6, null, [[3, 9]]);
      }))();
    },
    salvarWhatsApp: function salvarWhatsApp(respostaNumero) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this14$cliente, _this14$inputs$tel;
        var payload, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (!(_this14.verificar && !_this14.validar())) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              if (_this14.verificar) {
                _this14.removerMensagens(_this14.error ? 3 : 2);
                _this14.adicionarMensagens([{
                  tipo: "texto-cliente",
                  conteudo: _this14.inputs.tel
                }]);
              }
              _this14.error = false;
              _this14.digitandoMensagem = true;
              payload = {
                cliente_id: ((_this14$cliente = _this14.cliente) === null || _this14$cliente === void 0 ? void 0 : _this14$cliente.id) || null,
                status: "ATIVO",
                numero: (_this14$inputs$tel = _this14.inputs.tel) === null || _this14$inputs$tel === void 0 ? void 0 : _this14$inputs$tel.replace(/\D/g, ""),
                identificador: _this14.identificador
              };
              _context7.p = 2;
              if (respostaNumero) {
                _context7.n = 3;
                break;
              }
              _context7.n = 3;
              return Promise.allSettled([_this14.cadastrarSms(payload), _this14.cadastrarLigacao(payload)]);
            case 3:
              _context7.n = 4;
              return _this14.cadastrarWhatsapp([payload]);
            case 4:
              _this14.$store.state.chat.mensagens--;
              _context7.n = 5;
              return _this14.sleep();
            case 5:
              _this14.digitandoMensagem = false;
              if (!_this14.cliente.tem_push) {
                _this14.adicionarMensagens(_this14.mensagemPedirPush("Perfeito! Agora, você aceita receber nossas notificações? \
                Assim você não perde nenhuma informação sobre seus próximos \
                boletos. Lembrando que é necessário permitir as notificações \
                no seu navegador."));
              } else {
                _this14.adicionarMensagens(_this14.mensagemSucesso());
              }
              _context7.n = 7;
              break;
            case 6:
              _context7.p = 6;
              _t3 = _context7.v;
              _this14.removerMensagens();
              _this14.error = true;
              if (_this14.verificar) {
                _this14.adicionarMensagens(_this14.mensagemErroWhatsapp(respostaNumero));
              } else {
                _this14.adicionarMensagens(_this14.mensagemRetryWhatsapp());
              }
            case 7:
              return _context7.a(2);
          }
        }, _callee7, null, [[2, 6]]);
      }))();
    },
    salvarPush: function salvarPush() {
      var _arguments2 = arguments,
        _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var aceitaPush, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              aceitaPush = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : true;
              _this15.removerMensagens(_this15.error ? 2 : 1);
              _this15.error = false;
              _this15.adicionarMensagens([{
                tipo: "texto-cliente",
                conteudo: aceitaPush ? "Aceito" : "Não aceito"
              }]);
              _this15.digitandoMensagem = true;
              _context8.n = 1;
              return _this15.sleep();
            case 1:
              _this15.digitandoMensagem = false;
              _this15.$store.state.chat.mensagens--;
              if (!aceitaPush) {
                _context8.n = 10;
                break;
              }
              if (!_this15.suportaNotificacao) {
                _context8.n = 7;
                break;
              }
              _context8.p = 2;
              _context8.n = 3;
              return _this15.cadastrarToken(_this15.identificador, _this15.cliente.tem_push);
            case 3:
              _this15.adicionarMensagens(_this15.mensagemPushAceito());
              _this15.digitandoMensagem = true;
              _context8.n = 4;
              return _this15.sleep();
            case 4:
              _this15.digitandoMensagem = false;
              _this15.adicionarMensagens(_this15.mensagemSucesso());
              _context8.n = 6;
              break;
            case 5:
              _context8.p = 5;
              _t4 = _context8.v;
              _this15.error = true;
              _this15.adicionarMensagens(_this15.mensagemRetryPush());
            case 6:
              _context8.n = 9;
              break;
            case 7:
              _this15.adicionarMensagens([{
                tipo: "texto-sistema",
                conteudo: "Obrigada, ".concat(_this15.cliente.nome, "! Voc\xEA sempre pode               contar com a gente! :)")
              }]);
              _this15.digitandoMensagem = true;
              _context8.n = 8;
              return _this15.sleep();
            case 8:
              _this15.digitandoMensagem = false;
              _this15.adicionarMensagens(_this15.mensagemSucesso());
            case 9:
              _context8.n = 12;
              break;
            case 10:
              _this15.digitandoMensagem = true;
              _context8.n = 11;
              return _this15.sleep();
            case 11:
              _this15.digitandoMensagem = false;
              _this15.adicionarMensagens(_this15.mensagemPushRecusado());
              _this15.adicionarMensagens(_this15.mensagemSucesso());
            case 12:
              return _context8.a(2);
          }
        }, _callee8, null, [[2, 5]]);
      }))();
    },
    atualizarInfosCliente: function atualizarInfosCliente() {
      this.cliente.tem_email = Boolean(this.cliente.email);
      this.cliente.tem_whatsapp = Boolean(this.cliente.whatsapp);
      this.cliente.telefone = Vue.filter("telefone")(this.cliente.celular);
      this.cliente.tem_push = this.cliente.tem_push;
    }
  })
};